var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cal-elec" },
    [
      _vm.windfarmId
        ? _c("map-control", {
            attrs: { icon: _vm.threeD, title: "3D" },
            on: { click: _vm.show3D }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }